<template>
    <div>
        <v-col cols="12" style="text-align: right;">
            <v-btn @click="clearMockup()">CLEAR MOCKUP</v-btn>
            &nbsp;
            <v-btn color="orange">CLOSE</v-btn>
        </v-col>

        <v-row>
            <v-col cols="2" v-for="(i,index) in listMockup" :key="index">
                <img :src="i.img_url" style="width:100%;cursor: pointer;" @click="assignMockupToVariants(i.img_url)"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name:"AddMockup",

        props:{
            listVariants: Array,
            listMockup: Array,
        },

        methods:{
            assignMockupToVariants(url){
                console.log('url: ',url)
                this.$root.$refs.crawledCreate.assignMockupToVariants(url)
            },

            clearMockup(){
                this.$root.$refs.crawledCreate.assignMockupToVariants(null)
            }
        },

        mounted(){
            console.log('listVariants: ', this.listVariants, ' - listMockup: ', this.listMockup)
        }
    }
</script>

<style lang="scss" scoped>

</style>